import { useGetAttachmentsByDocId } from "@/api/attachment";
import { Attachment } from "@/lib/types";
import { urlToFile } from "@/lib/utils";
import { useCallback, useEffect, useState } from "react";

const defaultQuality = "mediumPublicUrl";
function useImageAttachment(
  imagePosition: string,
  docId?: string,
  quality: Extract<
    "mediumPublicUrl" | "largePublicUrl",
    keyof Attachment
  > = defaultQuality,
) {
  const { data: imageAttachments, refetch } = useGetAttachmentsByDocId(docId);
  const [imageURL, setImageURL] = useState<string>();
  const [attachment, setAttachment] = useState<Attachment>();

  const loadImage = useCallback(async () => {
    const image = imageAttachments?.find(
      (attachment: Attachment) => attachment.position === imagePosition,
    );
    if (image) {
      urlToFile(image?.[quality] || "", "croppedImage.jpg", "image/jpg");
      setImageURL(image?.[quality]);
      setAttachment(image);
    }
  }, [imageAttachments, imagePosition, quality]);

  useEffect(() => {
    if (imageAttachments) {
      loadImage();
    }
  }, [imageAttachments, loadImage]);

  return { attachment, imageURL, refetch };
}

export default useImageAttachment;
